import {MailActionTypeKeys, MailActionTypes} from "../actions/mailActionTypes";
import IMessage from "../components/mail/model/Message";
import initialState from "./mailInitialState";

export default (
  state = initialState,
  action: MailActionTypes
) => {
  switch (action.type) {
    case MailActionTypeKeys.REFRESH_EMAIL_LIST: {
      let messageList = action.messageList;
      let selectedMessage = state.selectedMessage;
      const selectedMessageId = selectedMessage ? selectedMessage.id : '';
      if (selectedMessageId && state.messageList && !_hasSelectedMessages(state.messageList)) {
        // If a message is open in Preview, mark it as read
        messageList = _markAsRead(action.messageList, selectedMessageId);
      }
      if (!_containsMessage(messageList, selectedMessageId)) {
        // If the active message no longer exists in our file list, reset the active message field
        selectedMessage = messageList.length > 0 ? messageList[0] : {} as IMessage;
      }
      return { ...state, messageList, selectedMessage };
    }
    case MailActionTypeKeys.MARK_MESSAGE_READ:
      return state.messageList ? { ...state, messageList: _markAsRead(state.messageList, action.messageId) } : state;
    case MailActionTypeKeys.CHECK_UNCHECK_EMAILS:
      return { ...state, messageList: action.messageList };
    case MailActionTypeKeys.SELECT_EMAIL: {
      let selectedMessage = action.message;
      const messageList = state.messageList;
      if (!messageList || messageList.length === 0) {
        // If we have no messages, how are we selecting a message?
        selectedMessage = {} as IMessage;
      } else if (!_containsMessage(state.messageList, selectedMessage.id)) {
        // If the selected message isn't in our file list, instead select the first message
        selectedMessage = messageList[0];
        messageList[0].readStatus = 'read';
      }
      return { ...state, selectedMessage, messageList };
    }
    case MailActionTypeKeys.SET_SORT_FIELD_AND_ORDER:
      return { ...state, sortField: action.sortField, isDesc: action.isDesc };
    case MailActionTypeKeys.SAVE_PAGINATION_INFO:
      return { ...state, paginationInfo: action.paginationInfo };
    case MailActionTypeKeys.SET_DELETE_EDIT_MODE:
      return { ...state, deleteMode: action.deleteMode };
    case MailActionTypeKeys.SET_RELEASE_EDIT_MODE:
      return { ...state, releaseMode: action.releaseMode };
    case MailActionTypeKeys.CLEAR_MAIL_DATA:
      return { ...initialState };
    default:
      return state;
  }
}

function _containsMessage(messageList: IMessage[] | undefined, messageId: string): boolean {
  return !!messageList && !!messageId && messageList.filter(msg => msg.id === messageId).length > 0;
}

function _hasSelectedMessages(messageList: IMessage[]): boolean {
  return messageList.filter(m => m.selected).length > 0;
}

function _markAsRead(messageList: IMessage[], messageId: string): IMessage[] {
  return messageList.map(m => ({
    ...m,
    readStatus: m.id === messageId ? 'read' : m.readStatus
  }));
}



// WEBPACK FOOTER //
// ./src/reducers/mailReducer.ts